import { render, staticRenderFns } from "./Nrenvip.vue?vue&type=template&id=1804fe44&scoped=true&"
import script from "./Nrenvip.vue?vue&type=script&lang=js&"
export * from "./Nrenvip.vue?vue&type=script&lang=js&"
import style0 from "./Nrenvip.vue?vue&type=style&index=0&id=1804fe44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1804fe44",
  null
  
)

export default component.exports